<template>
    <div v-if="!!dropDownOptions && !!branchEnumMap">
        <GroupedMultiSelect
            :classes="classes"
            :optionEnumMap="branchEnumMap"
            :getProviderName="getProviderName"
            :getProviderApplication="getProviderApplication"
            :labelText="labelText"
            :searchText="searchText"
            :dropDownOptions="dropDownOptions"
            :selectedOptions="filterBranches"
            :isDisabled="isBranchLoading"
            v-on:updateFilterBranches="updateFilterBranches"
            :showPrimaryBranch="showPrimaryBranch"
            :isPrimaryLocationFilter="isPrimaryLocationFilter"
            :preserveSelectedBranches="preserveSelectedBranches"
            v-on:updatePrimaryLocationFilter="updatePrimaryLocationFilter"
        />
    </div>
</template>

<script src="./BranchDefaultFilter"></script>
